<template>
	<v-card class="elevation-0 px-5 item-list">
		<v-layout row grap>
			<v-row>
				<v-col cols="10" sm="7" md="9">
					<confirm-dialog
						:confirmDialog="confirmDialog"
						:message="dialogMessage"
						@confirm="dialogConfirmAction"
						@cancel="cancelDialog"
					/>
				</v-col>
			</v-row>
		</v-layout>
		<v-card-title class="all-header">
			<v-layout row grap>
				<v-row class="header">
					<v-col cols="12" sm="12" md="6" lg="6" class="title-view">
						<p class="title-proyects mt-2">{{ title }}</p>
					</v-col>
					<v-col cols="12" sm="12" md="6" lg="6" class="title-view-search">
						<v-text-field
							v-model="search"
							clear-icon="mdi-close-circle-outline"
							append-icon="mdi-magnify"
							:label="searchLabel"
							single-line
							hide-details
							@keydown="searchInput"
							background-color="#ededed"
							color="#2196F3"
							class="pa-0 ma-0 search-bar"
							flat
							rounded
							clearable
							v-if="this.$route.path !== '/statistics'"
						></v-text-field>
					</v-col>
				</v-row>
			</v-layout>
		</v-card-title>
		<v-card-title class="all-header">
			<v-layout>
				<v-row class="header">
					<v-col cols="12" sm="12" md="6" lg="6" class="statistics-header">
						<p
							class="title-proyects-statistics mt-2"
							v-if="this.$route.path === '/statistics'"
						>
							{{ $t("informationRelatedTo") }}
						</p>
						<v-select
							v-model="selectedStatistic"
							:items="statisticsOptions"
							class="select filter"
							item-text="type"
							item-value="value"
							v-if="this.$route.path === '/statistics'"
						>
						</v-select>
					</v-col>
					<v-col cols="12" sm="12" md="6" lg="6">
						<CalendarStatistics v-if="$route.path === '/statistics'" />
						<v-row class="search-statistics"> </v-row>
					</v-col>
				</v-row>
			</v-layout>
		</v-card-title>
		<v-row class="search-statistics mb-5">
			<v-text-field
				v-model="search"
				clear-icon="mdi-close-circle-outline"
				append-icon="mdi-magnify"
				:label="searchLabel"
				single-line
				hide-details
				@keydown="searchInput"
				background-color="#ededed"
				color="#2196F3"
				class="pa-0 ma-0 search-bar-statistics"
				flat
				rounded
				clearable
				v-if="this.$route.path === '/statistics'"
			></v-text-field>
		</v-row>
		<v-layout>
			<v-row
				v-if="
					$route.path === '/statistics' && selectedStatistic === $t('cameras')
				"
				class="show-map"
			>
				<p @click="showMapDialog()" class="show-map-text">
					{{ $t("showMap") }}
				</p>
			</v-row>
		</v-layout>
		<v-layout v-if="showStatusFilter && isAuditor()">
			<v-row class="filter-row">
				<v-select
					v-model="statusSelected"
					:items="status"
					:label="$t('filterByStatus')"
					class="filter-state mr-10 pt-0"
					item-text="label"
					item-value="value"
					clearable
					@change="selected()"
					v-if="$route.path !== '/statistics'"
				></v-select>
			</v-row>
		</v-layout>
		<v-data-table
			:items="items"
			item-key="timestamp"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:headers="headers"
			:items-per-page="itemsPerPage"
			:hide-default-footer="true"
			class="project-table keep-spaces"
		>
			<template #item.cameraName="{item}">
				<v-col class="col-item camera-name">
					<span @click="showMap(item)">{{ item.cameraName }}</span>
				</v-col>
			</template>
			<template #item.totalHoursRequested="{item}">
				<v-col class="col-item">
					{{ getHours(item.totalHoursRequested) }}
				</v-col>
			</template>
			<template #item.totalHoursExtracted="{item}">
				<v-col class="col-item">
					{{ getHours(item.totalHoursExtracted) }}
				</v-col>
			</template>
			<template #item.project="{item}">
				<v-col class="col-item">
					{{ item.project }}
				</v-col>
			</template>
			<template #item.timestamp="{ item }">
				<v-col class="col-item">
					{{ parseTimePeriod(item.timestamp) }}
				</v-col>
			</template>
			<template #item.statusLogs="{ item }">
				<v-col class="col-item size-data">
					{{ item.statusLogs.changedBy }}
				</v-col>
			</template>
			<template #item.crimeType="{ item }">
				<v-col class="col-item size-data">
					{{ item.crimeType }}
				</v-col>
				<v-col class="col-item" v-if="item.crimeType === null">
					---
				</v-col>
			</template>
			<template #item.totalHours="{ item }">
				<v-col class="col-item size-data">
					{{ getHours(item.totalHours) }}
				</v-col>
			</template>
			<template #item.creationDate="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.creationDate !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.creationDate) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.preApproved="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.preApproved !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.preApproved) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.approved="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.approved !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.approved) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.denied="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.denied !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.denied) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.organism="{ item }">
				<v-col class="col-item size-data">
					{{ item.organism }}
				</v-col>
				<v-col class="col-item" v-if="item.organism === null">
					---
				</v-col>
			</template>
			<template #item.expirationDate="{ item }">
				<v-col class="col-item size-data">
					<ExpirationCounter :date="item.expirationDate" />
				</v-col>
			</template>
			<template #item.additionalInfo="{ item }">
				<v-col class="col-item">
					<div v-if="item.statusChange != 'Extracting'">
						<b>{{ additionalInfo(item.statusChange) }}</b>
						{{ item.additionalInfo }}
					</div>
					<div v-else-if="item.additionalInfo.length">
						{{
							$t("extractingTime", {
								time: getHours(
									parseFloat(item.additionalInfo.replace(",", "."))
								),
							})
						}}
					</div>
				</v-col>
			</template>
			<template #item.statusChange="{ item }">
				<status-box :status="item.statusChange" class="col-item status" />
			</template>
			<template v-if="hasCard" #item="{ item, index }">
				<slot name="itemCard" v-bind:item="item" :index="index"></slot>
			</template>
			<template #item.actions="{ item }">
				<icon
					icon="mdi-pencil"
					@clicked="editOrganism(item)"
					:name="$t('iconEditOrganism')"
				/>
				<icon
					icon="mdi-delete"
					@clicked="initDeleteProcess(item)"
					:disableIcon="!item.canDelete"
					:name="$t('iconDeleteOrganism')"
				/>
			</template>
			<template slot="no-data">
				<p>{{ $t("noResults") }}</p>
			</template>
			<template #footer>
				<slot name="tfooter"></slot>
			</template>
		</v-data-table>

		<!--Esta tabla es para el responsive de projects-->
		<v-data-table
			:items="items"
			:headers="headers"
			:server-items-length="this.items.length"
			:hide-default-footer="true"
			class="hidden-md-and-up table-resp"
			mobile-breakpoint="962"
			disable-sort
		>
			<template #item.statusChange="{ item }">
				<status-box :status="item.statusChange" />
			</template>
			<template #item.actions="{ item }">
				<icon
					icon="mdi-pencil"
					@clicked="editOrganism(item)"
					:name="$t('iconEditOrganism')"
				/>
				<icon
					icon="mdi-delete"
					@clicked="initDeleteProcess(item)"
					:disableIcon="!item.canDelete"
					:name="$t('iconDeleteOrganism')"
				/>
			</template>
			<template v-if="hasCard" #item="{ item }">
				<slot name="itemCardRes" v-bind:item="item"></slot>
			</template>
			<template #item.totalHours="{ item }">
				<v-col class="col-item size-data">
					{{ getHours(item.totalHours) }}
				</v-col>
			</template>
			<template #item.creationDate="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.creationDate !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.creationDate) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.preApproved="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.preApproved !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.preApproved) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.approved="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.approved !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.approved) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.denied="{ item }">
				<v-col
					class="col-item size-data"
					v-if="item.denied !== '0001-01-01T00:00:00'"
				>
					{{ datetime(item.denied) }}
				</v-col>
				<v-col v-else>
					---
				</v-col>
			</template>
			<template #item.statusLogs="{item}">
				<v-col class="col-item">
					{{ item.statusLogs.changedBy }}
				</v-col>
			</template>
			<template #item.expirationDate="{ item }">
				<v-col class="col-item size-data">
					<ExpirationCounter :date="item.expirationDate" />
				</v-col>
			</template>
			<template #footer>
				<slot name="tfooter"></slot>
			</template>
			<template slot="no-data">
				<p>{{ $t("noResults") }}</p>
			</template>
		</v-data-table>
		<v-container
			v-if="
				$route.path === '/statistics' && selectedStatistic === $t('projects')
			"
			class="graph-container"
		>
			<v-layout row>
				<v-row justify="center" class="mr-0 mt-3">
					<v-col cols="9" sm="5" md="3">
						<v-simple-table class="simple-table">
							<template v-slot:default>
								<tbody>
									<tr class="gris">
										<td class="header-table text-center">
											{{ Math.round(total.totalHoursExtracted) }}
										</td>
									</tr>
									<tr>
										<td class="header-table text-center">
											{{ $t("totalHoursExtracted") }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="9" sm="5" md="3">
						<v-simple-table class="simple-table">
							<template v-slot:default>
								<tbody>
									<tr class="gris">
										<td class="header-table text-center">
											{{ total.totalProjects }}
										</td>
									</tr>
									<tr>
										<td class="header-table text-center">
											{{ $t("totalProjects") }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
					<v-col cols="9" sm="5" md="3">
						<v-simple-table class="simple-table">
							<template v-slot:default>
								<tbody>
									<tr class="gris">
										<td class="header-table text-center">
											{{ total.totalDownloads }}
										</td>
									</tr>
									<tr>
										<td class="header-table text-center">
											{{ $t("totalDownloads") }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
					<v-col cols="9" sm="5" md="3">
						<v-simple-table class="simple-table">
							<template v-slot:default>
								<tbody>
									<tr class="gris">
										<td class="header-table text-center">
											{{ total.totalCamerasExtracted }}
										</td>
									</tr>
									<tr>
										<td class="header-table text-center">
											{{ $t("totalCamerasExtracted") }}
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
			</v-layout>
			<ProjectsGraphs class="pt-5" />
		</v-container>
		<v-dialog v-model="isShowMap" width="85%">
			<v-card>
				<v-card-title class="subtitle-1 grey lighten-2">
					<v-row>
						<v-col cols="11" sm="10" class="pa-0 map-title">{{
							$t("camerasRequested")
						}}</v-col>
						<v-col
							cols="1"
							sm="2"
							class="text-right pa-0"
							@click="isShowMap = false"
							style="cursor:pointer"
							>X</v-col
						>
					</v-row>
				</v-card-title>

				<map-display
					class="map-cameras"
					:markers="items"
					:isStatistics="true"
					:cameraSelected="cameraSelected"
					:key="mapKey"
				/>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import ProjectsGraphs from "@/views/statisticsView/components/ProjectsGraphs";
import DateParseMixin from "@/mixins/DateParseMixin";
import ExpirationCounter from "@/views/mainView/components/ExpirationCounter";
import CalendarStatistics from "@/views/statisticsView/components/CalendarStatistics";
export default {
	components: {
		Icon: () => import("@/components/base/Icon"),
		ConfirmDialog: () => import("@/components/base/ConfirmDialog"),
		MapDisplay: () => import("@/components/base/Map"),
		ExpirationCounter,
		ProjectsGraphs,
		CalendarStatistics,
	},
	props: {
		items: {
			type: Array,
			default: function() {
				return [];
			},
		},

		headers: {
			type: Array,

			default: function() {
				return [];
			},
		},

		bottomText: {
			type: String,

			default: "",
		},
		callback: {},

		hasCard: {
			type: Boolean,
			default: false,
		},
		searchLabel: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: "",
		},
		itemsPerPage: {
			type: Number,
			default: 10,
		},
		total: {
			type: Object,
			default: () => {
				return {
					totalProjects: 0,
					totalHoursExtracted: 0,
					totalDownloads: 0,
					totalCamerasExtracted: 0,
				};
			},
		},
		statusEndpoint: {
			type: String,
			default: "getstatus",
		},
		showStatusFilter: {
			type: Boolean,
			default: true,
		},
	},
	mixins: [DateParseMixin],
	data() {
		return {
			statisticsOptions: [
				this.$t("projects"),
				this.$t("cameras"),
				this.$t("system"),
			],
			sortBy: undefined,
			sortDesc: undefined,
			elem: "",
			lock: 0,
			confirmDialog: false,
			dialogMessage: undefined,
			isShowMap: false,
			dialogConfirmAction: function() {},
			targetOrganism: undefined,
			status: [],
			isStatistics: false,
			cameraSelected: "",
			mapKey: 0,
			camerasNoLocation: [],
		};
	},
	computed: {
		search: {
			get() {
				return this.$store.getters.getSearch;
			},
			set(value) {
				return this.$store.commit("setSearch", value);
			},
		},
		statusSelected: {
			get() {
				return this.$store.getters.getStatus;
			},
			set(value) {
				return this.$store.commit("setStatus", value);
			},
		},
		selectedStatistic: {
			get() {
				return this.$store.getters.getSelectedStatistic;
			},
			set(value) {
				return this.$store.commit("setSelectedStatistic", value);
			},
		},
		searchView: {
			get() {
				return this.$store.getters.getSearch;
			},
			set(value) {
				return this.$store.commit("setSearch", value);
			},
		},
		start: {
			get() {
				return this.$store.getters.getStartDate;
			},
			set(value) {
				return this.$store.commit("setStartDate", value);
			},
		},
		rangeDates: {
			get() {
				return this.$store.getters.getRange;
			},
			set(value) {
				return this.$store.commit("setRange", value);
			},
		},
	},
	mounted() {
		if (this.showStatusFilter) {
			this.getAllStatus();
		}
		if (this.isStatistics) {
			this.getCamerasNoLocation();
		}
	},
	updated: function() {
		if (this.elem !== "undefined") {
			this.elem = document.querySelectorAll("tr");
			this.elem.forEach((e, index) => {
				if (index % 2 === 1) {
					e.classList.add("row-background-gray");
				} else {
					e.classList.add("row-background-white");
				}
			});
		}
	},
	watch: {
		sortBy: function(newVal, oldVal) {
			if (newVal !== oldVal && this.sortDesc !== undefined) {
				this.$emit(
					"sortBy",
					newVal[0],
					this.sortDesc[0] === undefined ? false : this.sortDesc[0]
				);
			}
		},
		sortDesc: function(newVal) {
			this.$emit("sortBy", this.sortBy[0], newVal[0]);
		},
		start: function(newVal, oldVal) {
			// watch it
			this.startDate = newVal;
			if (newVal != oldVal && this.isStatistics) {
				this.getCamerasNoLocation();
			}
		},
		rangeDates: function(newVal, oldVal) {
			// watch it
			this.range = newVal;
			if (newVal != oldVal && this.isStatistics) {
				this.getCamerasNoLocation();
			}
		},
	},

	methods: {
		getCamerasNoLocation() {
			this.camerasNoLocation = [];
			this.$extractions
				.getHeatMap(this.searchView, this.start, this.rangeDates)
				.then((res) => {
					res.data.forEach((c) => {
						if (c.geoLocation === null) {
							this.camerasNoLocation.push(c.cameraName);
						}
					});
				})
				.catch((e) => {
					console.log("Error: ", e);
				});
		},
		showMap(item) {
			if (!this.camerasNoLocation.includes(item.cameraName)) {
				this.isShowMap = !this.isShowMap;
				this.cameraSelected = item.cameraName;
				this.mapKey++;
			} else {
				this.$store.dispatch(
					"noCameraAlert",
					this.$t("thisCameraHasNoLocation")
				);
			}
		},
		showMapDialog() {
			this.isShowMap = !this.isShowMap;
			this.mapKey++;
			this.cameraSelected = "";
		},
		getHours(duration) {
			var seconds = parseInt((duration / 1000) % 60),
				minutes = parseInt((duration / (1000 * 60)) % 60),
				hours = parseInt((duration / (1000 * 60 * 60)) % 24),
				days = parseInt(duration / (1000 * 60 * 60 * 24));
			hours += days * 24;
			hours = hours < 10 ? "0" + hours : hours;
			minutes = minutes < 10 ? "0" + minutes : minutes;
			seconds = seconds < 10 ? "0" + seconds : seconds;

			return hours + ":" + minutes + ":" + seconds;
		},
		datetime(item) {
			var aux = new Date(item);
			return new Date(aux.toString() + " UTC").toLocaleString();
		},
		isAuditor() {
			if (
				this.$store.getters.getRole === "legal_auditor" ||
				this.$store.getters.getRole === "auditor" ||
				this.$store.getters.getRole === "admin"
			) {
				return true;
			} else {
				return false;
			}
		},
		getAllStatus() {
			this.$extractions
				.getStatus(this.statusEndpoint)
				.then((response) => {
					response.data.forEach((s) => {
						this.status.push({ value: s, label: this.$t("resultStatus." + s) });
					});
				})
				.catch((e) => {
					console.log("Error: ", e);
				});
		},
		searchInput() {
			if (this.lock < 1) {
				this.lock++;
				setTimeout(() => {
					this.$emit("search", this.search);
					this.lock--;
				}, 1000);
			}
		},

		selected() {
			this.$emit("status", this.status);
		},
		additionalInfo(status) {
			console.log("status", status);
			if (status.toString().includes("Download")) {
				return this.$t("additionalTextForDownloads");
			} else if (status.toString().includes("shared")) {
				return this.$t("sharedData");
			}

			return "";
		},
		editOrganism(item) {
			this.$store.commit("setIsOrganismEditMode", true);
			this.$store.commit("setOrganismEdition", item);
			this.$router.push("/organism/create");
		},
		//delete process
		initDeleteProcess(item) {
			this.targetOrganism = item;
			this.confirmDialog = true;
			this.dialogMessage = this.$t("messageDeleteOrganism");
			this.dialogConfirmAction = this.deleteItem;
		},
		/*delete organism*/
		deleteItem() {
			this.$extractions
				.deleteOrganism(this.targetOrganism)
				.then(() => {
					this.$store.dispatch("snackAlert", true);
					this.targetOrganism = undefined;
				})
				.catch((err) => {
					this.$store.dispatch("snackAlert", false);
					console.log("error", err);
					this.targetOrganism = undefined;
				});
			this.confirmDialog = false;
		},
		//cancelDialog
		cancelDialog() {
			this.confirmDialog = false;
			this.targetOrganism = undefined;
		},
	},
};
</script>
<style>
.all-header {
	padding: 0 15px !important;
}
.statistics-header {
	justify-content: flex-start !important;
	display: flex !important;
}
.search-bar-statistics {
	max-width: 320px !important;
}
.search-bar {
	justify-content: flex-end !important;
	display: grid !important;
}
.search-statistics {
	justify-content: flex-end !important;
	margin-right: 15px !important;
}
.map-title {
	justify-content: space-between !important;
}
.show-map {
	justify-content: flex-end !important;
	margin-right: 10px !important;
}
.show-map p {
	margin-right: 20px !important;
	margin-bottom: 0 !important;
	cursor: pointer !important;
	color: #2196f3 !important;
}
.camera-name:hover {
	color: #2196f3 !important;
	cursor: pointer !important;
}
.title-view {
	text-align: left !important;
}
.title-view-search {
	text-align: left !important;
	justify-content: flex-end !important;
	display: grid !important;
}
.size-data {
	font-size: 13px !important;
}
.status-statistics {
	display: none !important;
}
.filter {
	max-width: 130px !important;
	padding-top: 3px !important;
}
.filter-state {
	max-width: 220px !important;
}
.filter-row {
	justify-content: flex-end !important;
}
.row-background-gray {
	background-color: #f8faff !important;
}
.row-background-gray:hover {
	background-color: #f8faff !important;
}
.row-background-white {
	background-color: #fff !important;
}
.row-background-white:hover {
	background-color: #fff !important;
}
.status {
	font-weight: normal !important;
}
.col-item {
	color: #868691 !important;
	padding: 0px !important;
}
.title-proyects {
	font-size: 18px;
	font-family: "Roboto", "sans-serif" !important;
	color: #0d5ae5;
	display: inline-block !important;
}
.title-proyects-statistics {
	font-size: 16px;
	font-family: "Roboto", "sans-serif" !important;
	color: #0d5ae5;
	display: inline-block !important;
}
.select {
	display: inline-block !important;
	margin-left: 10px !important;
	font-size: 12px !important;
}
.header {
	justify-content: space-between;
}
.filter .v-label {
	font-size: 12px !important;
	font-family: "Epilogue", "sans-serif" !important;
	padding-top: 5px;
	padding-left: 5px;
}
.search-bar .v-label {
	font-size: 12px !important;
	font-family: "Epilogue", "sans-serif" !important;
	padding-top: 5px;
	padding-left: 5px;
}
.search-bar-statistics .v-label {
	font-size: 12px !important;
	font-family: "Epilogue", "sans-serif" !important;
	padding-top: 5px;
	padding-left: 5px;
}
.v-text-field__slot {
	padding: 5px !important;
}
.v-input__append-inner {
	padding-top: 5px;
}
.project-table {
	border: 1px solid #eee !important;
	border-radius: 18px;
}
.v-data-table th {
	border-bottom: none !important;
}
.v-data-table td {
	border-bottom: none !important;
	font-family: "Open Sans", "sans-serif" !important;
	font-weight: 500;
}
.text-left {
	border-bottom: none !important;
}
.filter-status {
	justify-content: flex-end !important;
}
.search-bar {
	width: 320px !important;
}
.keep-spaces {
	white-space: pre-wrap;
}
@media (max-width: 1050px) {
	.select {
		width: 30% !important;
	}
	.filter {
		max-width: 28% !important;
	}
}

@media (max-width: 960px) {
	.row-background-gray {
		background-color: #f8faff !important;
	}
	.row-background-gray:hover {
		background-color: #f8faff !important;
	}
	.title-proyects {
		font-size: 18px;
		font-family: "Roboto", "sans-serif" !important;
		color: #0d5ae5;
		display: inline-block !important;
		margin-right: 5px !important;
	}
	.row-background-white {
		background-color: #fff !important;
	}
	.row-background-white:hover {
		background-color: #fff !important;
	}

	.theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
	.theme--light.v-data-table tbody tr:not(:last-child) th:last-child {
		border-bottom: 1px solid #ccc !important;
	}

	.filter {
		max-width: 25% !important;
	}
	.search-bar {
		width: 350px !important;
	}
	.v-data-table__mobile-row__header {
		text-align: left !important;
	}
	.map-cameras {
		height: 500px !important;
		width: 1000px !important;
		margin-left: 0 !important;
		padding-left: 0 !important;
		z-index: 0 !important;
	}
}
@media (max-width: 958px) {
	.project-table {
		display: none;
	}
	.v-application .px-5 {
		padding-left: 0px !important;
		padding-right: 5px !important;
	}
	.map-title {
		font-size: 14px !important;
	}
}
@media (max-width: 900px) {
	.col-item {
		font-size: 12px !important;
	}
	.filter {
		max-width: 40% !important;
	}
}
@media (max-width: 800px) {
	.col-item {
		font-size: 12px !important;
	}
	.title-proyects {
		font-size: 17px !important;
	}
	.search-bar {
		width: 500px !important;
	}
}
@media (max-width: 600px) {
	.v-data-table__mobile-row__cell {
		width: 70% !important;
	}
	.v-data-table__mobile-row__header {
		font-size: 12px !important;
	}
	.graph-container {
		max-width: 100% !important;
		padding: 0 !important;
		margin-left: 10px !important;
	}
	.title-proyects {
		font-size: 16px !important;
	}
	.map-title {
		font-size: 13px !important;
	}
}

@media (max-width: 700px) {
	.select {
		width: 25% !important;
	}
	.search-bar {
		width: 300px !important;
	}
}
@media (max-width: 550px) {
	.item-list {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
	.filter {
		max-width: 45% !important;
	}
	.select {
		width: 30% !important;
	}
}
@media (max-width: 500px) {
	.filter {
		max-width: 50% !important;
	}
	.select {
		width: 50% !important;
	}
	.map-title {
		font-size: 12px !important;
	}
}
@media (max-width: 450px) {
	.search-bar .v-input__slot {
		width: 250px !important;
	}
	.v-data-table__mobile-row__header {
		width: 140px !important;
	}
	.graph-container {
		max-width: 98% !important;
	}
	@media (max-width: 900px) {
		.col-item {
			font-size: 12px !important;
		}
	}
	.v-data-table__mobile-row__cell {
		width: 60% !important;
	}

	.filter {
		max-width: 45% !important;
	}
	.table-resp {
		margin-left: -20px !important;
	}
}
@media (max-width: 330px) {
	.search-bar {
		width: 180% !important;
	}
}
</style>
